<template>
    <section class="comment__entry">
        <div class="comment__entry--header">
            <img v-if="comment.author.image" :src="'https://api.library.loxone.com'+comment.author.image" />
            <img v-else src="https://api.library.loxone.com/files/global/user.png"  width="48" height="48" />
            <div class="comment__meta">
                <span class="comment__user">
                    <span>{{comment.author.displayname}}</span>
                </span>
                <span class="comment__time">&nbsp;-&nbsp;{{formatDate(comment.date)}}</span>
                <span v-if="comment.rating" class="comment__rating">
                        <svg v-for="star in comment.rating" :key="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path  fill="#575C61" d="m55,237 74-228 74,228L9,96h240"/></svg>
                        <svg v-for="star in 5 - comment.rating" :key="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path fill="rgb(87,92,97, 0.25)" d="m55,237 74-228 74,228L9,96h240"/></svg>
                </span>
            </div>
        </div>
        <div class="comment__entry--body">
            <b style="font-size:24px;" v-if="comment.title">{{comment.title }}</b><br/>
            <p v-html="filterString(comment.text)"></p>
        </div>
        <div class="comment__entry--reply">
            <a v-if="$store.state.loggedIn" class="reply__button" @click="toggleReplyBox()">{{$t('page.detail.comments.reply')}}</a>
             <div v-if="$store.state.loggedIn && $store.state.userData.user_id == comment.author.id" class="controls">
                <span @click="deleteComment()">{{$t('page.detail.comments.delete')}}</span>
            </div>
            <div v-if="replyBoxVisible && $store.state.loggedIn" class="reply__box">
                <textarea class="styled" v-model="reply" id="comment" name="comment" rows="8" cols="93" :placeholder="$t('page.detail.comments.placeholder')"></textarea>
                <btn @click="resetReply()" :class="'btn--lightgray'" :text="$t('page.detail.comments.cancel')" />
                <btn @click="submitReply()" :text="$t('page.detail.comments.send')" />
            </div>
            <div class="reply__content">
                <comment-reply
                    v-for="reply in replies"
                    :key="reply.id"
                    :data="reply"
                    :type="type"></comment-reply>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios';
    import CommentReply from '@/components/CommentReply.vue';
    import Btn from '@/components/Button.vue';

    export default{

        props: {
            comment: {
                type: Object,
                required: true,
            },
            replies: {
                type: Object,
                required: true,
            },
            type: {
                type: String,
                required: true,
            }
        },

        components: {
            CommentReply,
            Btn
        },

        data() {
            return {
                replyBoxVisible: false,
                reply: '',
                plugin_id_url: window.location.href.split('/')[4].substring(window.location.href.split('/')[4].lastIndexOf('-') + 1),
            }
        },

        methods: {
            filterString(string = false) {
                if(string) {
                    string = string.replaceAll('\\n\\r', '<br>');
                    string = string.replaceAll('\\n', '<br>');
                    string = string.replaceAll('\\r', '<br>');
                    string = string.replaceAll('\\', '');
                    return string;
                }
                return "";
            },
            toggleReplyBox() {
                this.replyBoxVisible = !this.replyBoxVisible;
            },

            resetReply() {
                this.reply = '';
                this.replyBoxVisible = false;
            },

            submitReply() {
                var commentMeta = new FormData();
                commentMeta.append('comment_id', this.comment.id);
                commentMeta.append('user_id', this.$store.state.userData.user_id);
                commentMeta.append('plugin_id', this.plugin_id_url);
                commentMeta.append('text', this.reply);

                let actionUrl = 'https://api.library.loxone.com/addCommentReply';
                if(this.type == 'issue') {
                    actionUrl = 'https://api.library.loxone.com/addIssueReply';
                }

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: actionUrl,
                    data: commentMeta,
                }).then((resp) => {
                    location.reload()
                });
            },

            deleteComment() {
                var commentMeta = new FormData();
                commentMeta.append('comment_id', this.comment.id);
                commentMeta.append('user_id', this.$store.state.userData.user_id);
                let actionUrl = 'https://api.library.loxone.com/deleteComment';
                if(this.type == 'issue') {
                    actionUrl = 'https://api.library.loxone.com/deleteIssue';
                }

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: actionUrl,
                    data: commentMeta,
                }).then((resp) => {
                    location.reload()
                });
            },

            formatDate(date) {
                const time_difference = (Math.floor((new Date() - new Date(date)) / (1000*60*60*24)));
                if(time_difference > 365) {
                    if(Math.floor(time_difference / 365) == 1) {
                        return Math.floor(time_difference / 365) + ' year ago';
                    } else {
                        return Math.floor(time_difference / 365) + ' years ago';
                    }
                } else if(time_difference > 30) {
                    if(Math.floor(time_difference / 30) == 1) {
                        return Math.floor(time_difference / 30) + ' month ago';
                    } else {
                        return Math.floor(time_difference / 30) + ' months ago';
                    }
                }
                switch(time_difference){
                    case 0:
                        return this.$t('page.detail.comments.today');
                    case 1:
                        return this.$t('page.detail.comments.yesterday');
                    default:
                        return this.$t('page.detail.comments.days_ago_pre') + time_difference + this.$t('page.detail.comments.days_ago_post');
                }
            }
        },
    }
</script>